module.exports = __webpack_public_path__ + "static/img/intervi-12.ff2224f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/persons/intervi-12.jpg
// module id = 0gcd
// module chunks = 0